import * as type from '../actions/types';

const initialState = {
    conversations: [],
    loading: false,
    error: null,
}

export default function inConversationData(state = initialState, action) {
    switch (action.type) {
        case type.GET_IN_CONVERSATION_DATA_REQUESTED:
            return {
                ...state,
                loading: true,
            }
        case type.GET_IN_CONVERSATION_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                conversations: action.data.in_conversation,
            }
        case type.GET_IN_CONVERSATION_DATA_FAILED:
            return {
                ...state,
                loading: false,
                error: action.message,
            }
        default:
            return state
    }
}